import { IServiceResponse } from "../interfaces/IServiceResponse";

export class ServiceResponse implements IServiceResponse {
    isSuccessful: boolean;
    resultMessage: string;
    value: any;

    constructor(config: IServiceResponse) {
        this.isSuccessful = config.isSuccessful;
        this.resultMessage = config.resultMessage;
        this.value = config.value;
    }
}